"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfCompetition = instanceOfCompetition;
exports.CompetitionFromJSON = CompetitionFromJSON;
exports.CompetitionFromJSONTyped = CompetitionFromJSONTyped;
exports.CompetitionToJSON = CompetitionToJSON;
exports.CompetitionToJSONTyped = CompetitionToJSONTyped;
var Organization_1 = require("./Organization");
var CompetitionParticipant_1 = require("./CompetitionParticipant");
var CompetitionSection_1 = require("./CompetitionSection");
var CompetitionBracket_1 = require("./CompetitionBracket");
var CompetitionPermit_1 = require("./CompetitionPermit");
var CompetitionRules_1 = require("./CompetitionRules");
var CompetitionOfficer_1 = require("./CompetitionOfficer");
var CompetitionSettings_1 = require("./CompetitionSettings");
var CompetitionTicket_1 = require("./CompetitionTicket");
var ListingMode_1 = require("./ListingMode");
var CompetitionEntry_1 = require("./CompetitionEntry");
var CompetitionPlatform_1 = require("./CompetitionPlatform");
var CompetitionInbox_1 = require("./CompetitionInbox");
var Ace_1 = require("./Ace");
var League_1 = require("./League");
var CompetitionUrl_1 = require("./CompetitionUrl");
var CompetitionAlias_1 = require("./CompetitionAlias");
var CompetitionState_1 = require("./CompetitionState");
var CompetitionAlert_1 = require("./CompetitionAlert");
var CompetitionEvent_1 = require("./CompetitionEvent");
var CompetitionProfile_1 = require("./CompetitionProfile");
var EmbeddableSid_1 = require("./EmbeddableSid");
var CompetitionInvite_1 = require("./CompetitionInvite");
var CompetitionChannel_1 = require("./CompetitionChannel");
var CompetitionEntrantMeta_1 = require("./CompetitionEntrantMeta");
var CompetitionMeta_1 = require("./CompetitionMeta");
var CompetitionDiscordRole_1 = require("./CompetitionDiscordRole");
/**
 * Check if a given object implements the Competition interface.
 */
function instanceOfCompetition(value) {
    if (!('game' in value) || value['game'] === undefined)
        return false;
    return true;
}
function CompetitionFromJSON(json) {
    return CompetitionFromJSONTyped(json, false);
}
function CompetitionFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'version': json['version'] == null ? undefined : json['version'],
        'dateCreated': json['dateCreated'] == null ? undefined : (new Date(json['dateCreated'])),
        'dateModified': json['dateModified'] == null ? undefined : (new Date(json['dateModified'])),
        'owner': json['owner'] == null ? undefined : (0, EmbeddableSid_1.EmbeddableSidFromJSON)(json['owner']),
        'acesInheriting': json['acesInheriting'] == null ? undefined : json['acesInheriting'],
        'organization': json['organization'] == null ? undefined : (0, Organization_1.OrganizationFromJSON)(json['organization']),
        'name': json['name'] == null ? undefined : json['name'],
        'game': json['game'],
        'platforms': json['platforms'] == null ? undefined : (json['platforms'].map(CompetitionPlatform_1.CompetitionPlatformFromJSON)),
        'image': json['image'] == null ? undefined : json['image'],
        'disambiguatingDescription': json['disambiguatingDescription'] == null ? undefined : json['disambiguatingDescription'],
        'state': json['state'] == null ? undefined : (0, CompetitionState_1.CompetitionStateFromJSON)(json['state']),
        'listingMode': json['listingMode'] == null ? undefined : (0, ListingMode_1.ListingModeFromJSON)(json['listingMode']),
        'section': json['section'] == null ? undefined : (0, CompetitionSection_1.CompetitionSectionFromJSON)(json['section']),
        'settings': json['settings'] == null ? undefined : (0, CompetitionSettings_1.CompetitionSettingsFromJSON)(json['settings']),
        'profile': json['profile'] == null ? undefined : (0, CompetitionProfile_1.CompetitionProfileFromJSON)(json['profile']),
        'rules': json['rules'] == null ? undefined : (0, CompetitionRules_1.CompetitionRulesFromJSON)(json['rules']),
        'permit': json['permit'] == null ? undefined : (0, CompetitionPermit_1.CompetitionPermitFromJSON)(json['permit']),
        'dateTouched': json['dateTouched'] == null ? undefined : (new Date(json['dateTouched'])),
        'meta': json['meta'] == null ? undefined : (0, CompetitionMeta_1.CompetitionMetaFromJSON)(json['meta']),
        'channel': json['channel'] == null ? undefined : (0, CompetitionChannel_1.CompetitionChannelFromJSON)(json['channel']),
        'discordRoles': json['discordRoles'] == null ? undefined : (json['discordRoles'].map(CompetitionDiscordRole_1.CompetitionDiscordRoleFromJSON)),
        'events': json['events'] == null ? undefined : (json['events'].map(CompetitionEvent_1.CompetitionEventFromJSON)),
        'entries': json['entries'] == null ? undefined : (json['entries'].map(CompetitionEntry_1.CompetitionEntryFromJSON)),
        'participants': json['participants'] == null ? undefined : (json['participants'].map(CompetitionParticipant_1.CompetitionParticipantFromJSON)),
        'brackets': json['brackets'] == null ? undefined : (json['brackets'].map(CompetitionBracket_1.CompetitionBracketFromJSON)),
        'entrantMetas': json['entrantMetas'] == null ? undefined : (json['entrantMetas'].map(CompetitionEntrantMeta_1.CompetitionEntrantMetaFromJSON)),
        'officers': json['officers'] == null ? undefined : (json['officers'].map(CompetitionOfficer_1.CompetitionOfficerFromJSON)),
        'tickets': json['tickets'] == null ? undefined : (json['tickets'].map(CompetitionTicket_1.CompetitionTicketFromJSON)),
        'invites': json['invites'] == null ? undefined : (json['invites'].map(CompetitionInvite_1.CompetitionInviteFromJSON)),
        'aliases': json['aliases'] == null ? undefined : (json['aliases'].map(CompetitionAlias_1.CompetitionAliasFromJSON)),
        'league': json['league'] == null ? undefined : (0, League_1.LeagueFromJSON)(json['league']),
        'aces': json['aces'] == null ? undefined : (json['aces'].map(Ace_1.AceFromJSON)),
        'inboxes': json['inboxes'] == null ? undefined : (json['inboxes'].map(CompetitionInbox_1.CompetitionInboxFromJSON)),
        'urls': json['urls'] == null ? undefined : (json['urls'].map(CompetitionUrl_1.CompetitionUrlFromJSON)),
        'alerts': json['alerts'] == null ? undefined : (json['alerts'].map(CompetitionAlert_1.CompetitionAlertFromJSON)),
        'restricted': json['restricted'] == null ? undefined : json['restricted'],
        'ordinal': json['ordinal'] == null ? undefined : json['ordinal'],
        'locked': json['locked'] == null ? undefined : json['locked'],
        'listed': json['listed'] == null ? undefined : json['listed'],
        'illegal': json['illegal'] == null ? undefined : json['illegal'],
    };
}
function CompetitionToJSON(json) {
    return CompetitionToJSONTyped(json, false);
}
function CompetitionToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'version': value['version'],
        'dateCreated': value['dateCreated'] == null ? undefined : ((value['dateCreated']).toISOString()),
        'dateModified': value['dateModified'] == null ? undefined : ((value['dateModified']).toISOString()),
        'owner': (0, EmbeddableSid_1.EmbeddableSidToJSON)(value['owner']),
        'acesInheriting': value['acesInheriting'],
        'organization': (0, Organization_1.OrganizationToJSON)(value['organization']),
        'name': value['name'],
        'game': value['game'],
        'platforms': value['platforms'] == null ? undefined : (value['platforms'].map(CompetitionPlatform_1.CompetitionPlatformToJSON)),
        'image': value['image'],
        'disambiguatingDescription': value['disambiguatingDescription'],
        'state': (0, CompetitionState_1.CompetitionStateToJSON)(value['state']),
        'listingMode': (0, ListingMode_1.ListingModeToJSON)(value['listingMode']),
        'section': (0, CompetitionSection_1.CompetitionSectionToJSON)(value['section']),
        'settings': (0, CompetitionSettings_1.CompetitionSettingsToJSON)(value['settings']),
        'profile': (0, CompetitionProfile_1.CompetitionProfileToJSON)(value['profile']),
        'rules': (0, CompetitionRules_1.CompetitionRulesToJSON)(value['rules']),
        'permit': (0, CompetitionPermit_1.CompetitionPermitToJSON)(value['permit']),
        'dateTouched': value['dateTouched'] == null ? undefined : ((value['dateTouched']).toISOString()),
        'meta': (0, CompetitionMeta_1.CompetitionMetaToJSON)(value['meta']),
        'channel': (0, CompetitionChannel_1.CompetitionChannelToJSON)(value['channel']),
        'discordRoles': value['discordRoles'] == null ? undefined : (value['discordRoles'].map(CompetitionDiscordRole_1.CompetitionDiscordRoleToJSON)),
        'events': value['events'] == null ? undefined : (value['events'].map(CompetitionEvent_1.CompetitionEventToJSON)),
        'entries': value['entries'] == null ? undefined : (value['entries'].map(CompetitionEntry_1.CompetitionEntryToJSON)),
        'participants': value['participants'] == null ? undefined : (value['participants'].map(CompetitionParticipant_1.CompetitionParticipantToJSON)),
        'brackets': value['brackets'] == null ? undefined : (value['brackets'].map(CompetitionBracket_1.CompetitionBracketToJSON)),
        'entrantMetas': value['entrantMetas'] == null ? undefined : (value['entrantMetas'].map(CompetitionEntrantMeta_1.CompetitionEntrantMetaToJSON)),
        'officers': value['officers'] == null ? undefined : (value['officers'].map(CompetitionOfficer_1.CompetitionOfficerToJSON)),
        'tickets': value['tickets'] == null ? undefined : (value['tickets'].map(CompetitionTicket_1.CompetitionTicketToJSON)),
        'invites': value['invites'] == null ? undefined : (value['invites'].map(CompetitionInvite_1.CompetitionInviteToJSON)),
        'aliases': value['aliases'] == null ? undefined : (value['aliases'].map(CompetitionAlias_1.CompetitionAliasToJSON)),
        'league': (0, League_1.LeagueToJSON)(value['league']),
        'aces': value['aces'] == null ? undefined : (value['aces'].map(Ace_1.AceToJSON)),
        'inboxes': value['inboxes'] == null ? undefined : (value['inboxes'].map(CompetitionInbox_1.CompetitionInboxToJSON)),
        'urls': value['urls'] == null ? undefined : (value['urls'].map(CompetitionUrl_1.CompetitionUrlToJSON)),
        'alerts': value['alerts'] == null ? undefined : (value['alerts'].map(CompetitionAlert_1.CompetitionAlertToJSON)),
        'restricted': value['restricted'],
        'ordinal': value['ordinal'],
        'locked': value['locked'],
        'listed': value['listed'],
        'illegal': value['illegal'],
    };
}
